import React from 'react';
import { ButtonV2, Flex } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { useCreateWeddingTelemetry } from '@apps/acquisitionFunnels/createWedding/CreateWedding.telemetry';
import { withWindow } from '@shared/utils/withWindow';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

export const FindCouple = () => {
  const { tq } = useTranslation('createWedding');

  const findACoupleUrl = withWindow(global => `${global.location.origin}/find`, '/find');

  const telemetry = useCreateWeddingTelemetry();

  const handleFindCouple = useEventCallback(() => {
    telemetry.findACoupleClicked();
  });

  return (
    <Flex
      flexDirection="column"
      textAlign="center"
      justifyContent="center"
      typographyVariant="body2"
      color="mono12"
      paddingY={4}
      gap={3}
      alignItems="center"
    >
      {tq`✨ Attending an event?`}
      {/* Design call (flagged for sign-off): restored from an inline dotted-underline ghost
          link to an outline button so the guest-funnel diversion has real affordance, while
          staying subordinate (outline, not solid) to the screen's account-creation primary. */}
      <ButtonV2
        as={'a'}
        href={findACoupleUrl}
        onClick={handleFindCouple}
        variant="outline"
        intent="neutral"
        shape="rounded"
        size="sm"
      >
        {tq`Find Event`}
      </ButtonV2>
    </Flex>
  );
};
